import { generated } from '@varos/research-sdk-api';
import { DocumentFormFormValues, DocumentFormFieldValues } from './state';
import { FormInterviewMetadata } from './formBuilderModel';

/**
 * Convert DocumentFormFieldValues to PropertyOperation format
 */
function mapFieldToPropertyOperation(
    field: DocumentFormFieldValues
): generated.PropertyOperation {
    return {
        id: field.id || undefined,
        display_name: field.title ?? '',
        description: field.description ?? undefined,
        type: field.type as any,
        required: field.required,
        formula: field.formula ?? undefined,
        config:
            field.type === 'enum' && field.options
                ? {
                      options: field.options.map(
                          (option): generated.PropertyEnumOptionCreatePayload => ({
                              display_name: option.displayName,
                          })
                      ),
                  }
                : null,
    } as generated.PropertyOperation;
}

/**
 * Converts form fields to PropertyOperation array for replace-all updates
 * (create/update based on ID presence, delete by omission)
 */
function buildFormFields(
    newFields: DocumentFormFieldValues[]
): generated.PropertyOperation[] {
    const newFieldOperations = [...newFields.map(mapFieldToPropertyOperation)];
    return newFieldOperations;
}

export function buildFormPayload(props: {
    values: DocumentFormFormValues;
    current: generated.Form; // Current form data for metadata
}): generated.FormUpdatePayload {
    const metadata: FormInterviewMetadata = {
        interview_agent_name: props.values.agentName ?? '',
        interview_agent_tone: props.values.tone ?? [],
        interview_goals: props.values.goals ?? '',
        interview_context: props.values.context ?? '',
    };

    const fields = buildFormFields(props.values.fields).filter(
        // TODO Dont modify the transcript. find better way to handle this
        (operation: generated.PropertyOperation) => operation.key !== 'transcript'
    );
    return {
        title: props.values.title ?? undefined,
        description: props.values.description ?? undefined,
        metadata,
        fields,
    };
}
